import { useCallback, useState } from 'react';
import { cloneDeep, isBoolean } from 'lodash';
import useServiceData from '../../../../hooks/useServiceData';
import { useService } from '../../../../redux/reducer/service';
import { ServiceDataKeys } from '../../constants/serviceData';

const initialState = Object.values(ServiceDataKeys).reduce((acc, key) => ({ ...acc, [key]: null }), {});

export function useSessionModalsControl() {
  const [modals, setModals] = useState(cloneDeep(initialState));
  const { serviceData } = useService();
  const { modalsData = {} } = serviceData ?? {};

  const { get, save } = useServiceData();

  const set = useCallback((key, value) => {
    setModals((prev) => {
      if (isBoolean(prev[key])) return prev;

      if (value) {
        const modalsData = get('modalsData') ?? {};
        !modalsData[key] && save('modalsData', { ...modalsData, [key]: true });
      }

      return { ...prev, [key]: value };
    });
  }, []);

  return {
    modals,
    modalsData,
    setModals,
    set,
  };
}
